import { z } from 'zod';

export const uuid = z.uuid();

export const slug = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[a-z0-9][a-z0-9-]*$/, 'lowercase letters, digits, and hyphens only');

export const paginationQuery = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});

export const errorResponse = z.object({
  error: z.string(),
  message: z.string(),
  statusCode: z.number(),
});
